<template>
	<main>
		<HeaderTab :title="$t('lieu.localisation_horse')" />

		<div id="content">
			<shutter-panel ref="shutterPanel" />
		</div>
	</main>
</template>

<script type="text/javascript">
	import Shutter from "@/mixins/Shutter.js"
	import ShutterMouvements from "@/mixins/shutters-manager/Mouvements.js"

	export default {
		name: 'LocalisationResidence',
		mixins: [Shutter, ShutterMouvements],
		data () {
			return {
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.setUpLocalisationResidence()
			},
		},

		components: {
			HeaderTab: () => import('@/components/HeaderTab'),
		}
	}

</script>